import React from "react";
import { useSelector } from "react-redux";

// components
import { Table } from "antd";
import { Header } from "../components/Header";

const { Column } = Table;

export const ExcelSummary = () => {
  const store = useSelector((state) => state?.Store);

  return (
    <>
      <Header title="اطلاعات اکسل" activeItem="dashboard" />
      <div className="mx-20 my-15">
        <div>صفحه: {store.excel_summary?.view}</div>
        <div>فایل: {store.excel_summary?.file_name}</div>
        <div>تعداد ایجاد شده: {store.excel_summary?.created_count}</div>
        <div>تعداد تغییر داده شده: {store.excel_summary?.updated_count}</div>
      </div>
      <Table
        size="small"
        scroll={{ x: 640 }}
        dataSource={store.excel_summary?.messages}
        pagination={false}>
        <Column width="8%" title="ردیف" dataIndex="row" key="row" />
        <Column width="8%" title="ستون" dataIndex="column" key="column" />
        <Column title="مقدار" dataIndex="value" key="value" />
        <Column
          title="پیغام‌ها"
          dataIndex="messages"
          key="messages"
          render={(messages) => (
            <div>
              {messages.map((message) => (
                <div>{message}</div>
              ))}
            </div>
          )}
        />
      </Table>
    </>
  );
};
